/** Brief 12, Bronlar. */
export const ruB12Bookings = {
  "bronK3.fromSearch": "Бронь из поиска туров",
  "bronK3.loading": "Получаем сообщения операторов…",
  "bronK3.empty.title": "Броней нет",
  "bronK3.empty.body": "Выберите вариант в поиске туров и забронируйте его: ответ туроператора будет виден здесь.",
  "bronK3.empty.cta": "Поиск туров",
  "bronK3.empty.filtered": "По этому фильтру броней нет.",
  "bronK3.error.title": "Брони не загрузились",
  "bronK3.error.body": "Сервер не ответил. Введённые данные сохранены, страницу можно безопасно перезагрузить.",
  "bronK3.alerts.title": "Сообщения операторов",
  "bronK3.alerts.count": "{count} · туристам ещё не сообщили",
  "bronK3.toClient": "Отправить клиенту",
  "bronK3.toFinance": "Передать в финансы",
  "bronK3.toFinance.done": "Передано в финансы · {name} · задача создана",
  "bronK3.toClient.done": "ИИ подготовил текст на узбекском · {name}: подтвердите в чате",
  "bronK3.toClient.noThread": "У клиента нет чата: передайте текст сами",
  "bronK3.openThread": "Открыть чат",
  "bronK3.ops.title": "Туроператоры",
  "bronK3.ops.all": "Все",
  "bronK3.ops.counts": "Броней: {bookings} · новых сообщений: {messages}",
  "bronK3.ops.debtTotal": "Всего долг {amount}",
  "bronK3.ops.debt": "Долг {amount}",
  "bronK3.ops.refund": "Возврат {amount}",
  "bronK3.ops.noDebt": "Долга нет",
  "bronK3.ops.cabinet": "Войти в кабинет",
  "bronK3.ops.reconnect": "Подключить заново",
  "bronK3.ops.broken": "Связь потеряна · войдите заново",
  "bronK3.ops.add": "Подключить оператора",
  "bronK3.ops.updatedHours": "Обновлено {hours} ч назад",
  "bronK3.ops.updatedDays": "Обновлено {days} дн назад",
  "bronK3.filter.operator": "Оператор",
  "bronK3.filter.status": "Статус",
  "bronK3.filter.all": "Все",
  "bronK3.filter.soon": "Вылет: ближайшие 30 дней",
  "bronK3.filter.deal": "Сделка №{number}",
  "bronK3.filter.client": "Этот клиент",
  "bronK3.filter.clear": "Снять фильтр",
  "bronK3.col.booking": "Бронь",
  "bronK3.col.tour": "Тур и клиент",
  "bronK3.col.dates": "Даты",
  "bronK3.messages.new": "Новых: {count}",
  "bronK3.messages.none": "Сообщения",
  "bronK3.pay.paid": "Оплачено",
  "bronK3.pay.partly": "Частично · осталось {amount}",
  "bronK3.pay.unpaid": "Не оплачено",
  "bronK3.pay.unpaidAmount": "Не оплачено · {amount}",
  "bronK3.pay.refund": "Возврат {amount}",
  "bronK3.pay.unknown": "Нет в кабинете",
  "bronK3.due.today": "сегодня до {time}",
  "bronK3.due.tomorrow": "завтра до {time}",
  "bronK3.due.date": "до {date} {time}",
  "bronK3.category.flight_change": "Изменение рейса",
  "bronK3.category.payment_due": "Срок оплаты",
  "bronK3.category.cancellation": "Отмена",
  "bronK3.category.confirmation": "Подтверждение",
  "bronK3.category.refund": "Возврат",
  "bronK3.category.document": "Документ",
  "bronK3.panel.head": "{operator} · Бронь {number}",
  "bronK3.panel.line": "{dates} · туристов: {count}",
  "bronK3.panel.sheet": "Бронь {number}",
  "bronK3.panel.notFound": "Бронь не найдена или вам не видна.",
  "bronK3.panel.docs": "Документы",
  "bronK3.panel.pays": "Оплата и сроки",
  "bronK3.panel.info": "Данные брони",
  "bronK3.panel.nameDiff": "Имя отличается. В паспорте:",
  "bronK3.panel.nameDiffBooking": "В брони:",
  "bronK3.panel.writeOperator": "Написать оператору",
  "bronK3.panel.nameFix": "Assalomu alaykum. Bron {number}: turist ismini pasportdagidek {name} deb tuzating.",
  "bronK3.panel.tourists": "Туристы",
  "bronK3.panel.noTourists": "Кабинет не передал список туристов.",
  "bronK3.panel.noCard": "Кабинет ещё не передал карточку брони: подробности на сайте оператора.",
  "bronK3.panel.expiryOk": "Действует · {month}",
  "bronK3.panel.expirySoon": "Срок близко · {month}",
  "bronK3.panel.hotel": "Отель",
  "bronK3.panel.room": "Номер",
  "bronK3.panel.meal": "Питание",
  "bronK3.panel.insurance": "Страховка",
  "bronK3.panel.extras": "Дополнительно",
  "bronK3.panel.outbound": "Туда",
  "bronK3.panel.inbound": "Обратно",
  "bronK3.panel.was": "Раньше было {time}",
  "bronK3.panel.clientCard": "Карточка клиента",
  "bronK3.panel.aiTitle": "Kapitan AI · кратко",
  "bronK3.panel.prepare": "Подготовить сообщение клиенту",
  "bronK3.panel.told": "Туристам сообщили",
  "bronK3.panel.read": "Прочитано",
  "bronK3.panel.readDone": "Прочитанное",
  "bronK3.panel.outboundBy": "Написал(а) {name}",
  "bronK3.panel.replyPlaceholder": "Пишите по-узбекски, переведём на русский",
  "bronK3.panel.replyLabel": "Ответ оператору",
  "bronK3.panel.translateFirst": "Сначала переведите на русский",
  "bronK3.panel.ru": "На русском",
  "bronK3.panel.passports": "Туристы и паспорт",
  "bronK3.panel.show": "Показать",
  "bronK3.panel.hide": "Скрыть",
  "bronK3.panel.journal": "Каждый просмотр записывается в журнал.",
  "bronK3.panel.payLeft": "Остаток",
  "bronK3.panel.payPaid": "Оплачено",
  "bronK3.panel.payState": "Статус",
  "bronK3.panel.payRefund": "Возврат",
  "bronK3.panel.payDue": "Срок",
} as const;
